import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SupplierSection from "../../../components/Settings/suppliers/SupplierSections";
import getSuppliersName from "../../../controllers/settings/supplier/getFlightSetting";
import getSuppliersList from "../../../controllers/settings/supplier/getSuppliersList";
import ManageHotelSuppliers from "./Hotel/ManageHotelSuppliers";
import ManageTourSuppliers from "./Tour/ManageTourSuppliers";
import getHotelSettings from "../../../controllers/hotelSettings/getHotelSettings";
import ManageInsuranceSuppliers from "./Insurance/ManageInsuranceSuppliers";
import ManageEsimSuppliers from "./Esim/ManageEsimSuppliers";
import ToggleSwitch from "../../../components/Settings/suppliers/ToggleSwitch";
import updateFlightSetting from "../../../controllers/settings/supplier/updateFlightSetting";
import { enqueueSnackbar } from "notistack";
import updateHotelSettings from "../../../controllers/hotelSettings/updateHotelSettings";
import { Menu, MenuItem } from "@mui/material";
import Icon from "../../../components/HOC/Icon";
import { Modal3 } from "../../../components/DIsplay/Modal/Modal3";
import TicketingAuthorizedAirlined from "./TicketingAuthorizedAirlines";
import BulkSupplierSettings from "./BulkSupplierSettings";
import SupplierTogglePicker from "./SupplierTogglePicker";
import Button1 from "../../../components/form/Button1";
import { setSupplierList, setGlobalEnabledSuppliers } from "../../../redux/reducers/settings/supplierSettingsSlice";

const Supplier = () => {
  const dispatch = useDispatch();
  const [loadings, setLoadings] = useState({ flight: true, hotel: true });
  const [flightProviders, setFlightProviders] = useState({});
  const [data, setData] = useState([]);
  const [autoTicket, setAutoTicket] = useState(false);
  const [hotelAutoTicket, setHotelAutoTicket] = useState(false);
  const [packageAutoTicket, setPackageAutoTicket] = useState(false);
  const [insuranceAutoTicket, setInsuranceAutoTicket] = useState(false);
  const [esimAutoTicket, setEsimAutoTicket] = useState(false);
  const [nobiPackageAutoTicket, setNobiPackageAutoTicket] = useState(false);

  const hotelProviders = [
    {
      title: "Suppliers",
      providers: [
        { initials: "HB", name: "Hotelbeds", toggle: false },
        { initials: "SA", name: "Sabre" },
      ],
    },
  ];

  const toursProviders = [
    {
      title: "Suppliers",
      providers: [
        { initials: "HB", name: "Hotelbeds", toggle: false },
        { initials: "SA", name: "Sabre" },
      ],
    },
  ];

  const getSuppliers = async () => {
    try {
      setLoadings((loadings) => ({ ...loadings, flight: true })); // Set loading to true before fetching
      const res = await getSuppliersName();
      const res2 = await getSuppliersList();
      setFlightProviders({ ...res.data, list: res2?.data });
      dispatch(setSupplierList(res2?.data));
      dispatch(
        setGlobalEnabledSuppliers(
          Array.isArray(res?.data?.enabledSuppliers)
            ? res.data.enabledSuppliers
            : [],
        ),
      );
      setAutoTicket(res?.data?.autoTicket);
    } catch (error) {
      console.error("Error fetching suppliers", error);
    } finally {
      setLoadings((loadings) => ({ ...loadings, flight: false })); // Set loading to false after fetching completes
    }
  };

  async function getHotelSuppliers() {
    setLoadings((loadings) => ({ ...loadings, hotel: true }));
    const res = await getHotelSettings();
    setLoadings((loadings) => ({ ...loadings, hotel: false }));
    if (res.return) {
      setData({
        hotelSuppliers: Object.entries(res?.data?.hotelSuppliers || {})?.map(
          ([key, obj]) => ({
            name: key,
            status: obj?.enabled,
            image: obj?.image,
          }),
        ),
        insuranceSuppliers: Object.entries(
          res?.data?.insuranceSuppliers || {},
        )?.map(([key, obj]) => ({
          name: key,
          status: obj?.enabled,
          image: obj?.image,
        })),
        packageSuppliers: Object.entries(
          res?.data?.packageSuppliers || {},
        )?.map(([key, obj]) => ({
          name: key,
          status: obj?.enabled,
          image: obj?.image,
        })),
        esimSuppliers: Object.entries(res?.data?.esimSuppliers || {})?.map(
          ([key, obj]) => ({
            name: key,
            status: obj?.enabled,
            image: obj?.image,
          }),
        ),
      });
      setHotelAutoTicket(res?.data?.hotelConfirmation === "Automatic");
      setPackageAutoTicket(res?.data?.packageConfirmation === "Automatic");
      setInsuranceAutoTicket(res?.data?.insuranceConfirmation === "Automatic");
      setEsimAutoTicket(res?.data?.esimConfirmation === "Automatic");
      setNobiPackageAutoTicket(
        res?.data?.nobiPackageConfirmation === "Automatic",
      );
    }
  }

  useEffect(() => {
    getSuppliers();
    getHotelSuppliers();

    //eslint-disable-next-line
  }, []);

  const autoTicketingEnabledAirlines =
    flightProviders?.autoTicketingEnabledAirlines;

  const allSuppliers = flightProviders?.list?.map((obj) => ({
    // code: obj?.value,
    code: obj?.value,
    autoTicketingEnabledAirlines:
      obj?.value === "Intra1A" ? autoTicketingEnabledAirlines : [],
    name: obj?.name,
    icon: obj?.icon,
    enabled: flightProviders?.enabledSuppliers?.includes(obj?.value),
    // enabled: flightProviders?.enabledSuppliers?.includes(obj?.value),
    autoTicketing: flightProviders?.autoTicketingEnabledSuppliers?.includes(
      obj?.value,
    ),
    // expiration: flightProviders?.bookingExpiration[obj?.value] || null,
    expiration: () => {
      try {
        return flightProviders?.bookingExpiration[obj?.value] || null;
      } catch (error) {
        return null;
      }
    },
  }));

  // console.log({ flightProviders });

  const localFlights = flightProviders?.list
    ?.filter((obj) => obj?.value.startsWith("Intra1"))
    ?.map((obj) => ({
      code: obj?.value,
      autoTicketingEnabledAirlines:
        obj?.value === "Intra1A" ? autoTicketingEnabledAirlines : [],
      name: obj?.name,
      icon: obj?.icon,
      enabled: flightProviders?.enabledSuppliers?.includes(obj?.value),
      autoTicketing: flightProviders?.autoTicketingEnabledSuppliers?.includes(
        obj?.value,
      ),
      expiration: () => {
        try {
          return flightProviders?.bookingExpiration[obj?.value] || null;
        } catch (error) {
          return null;
        }
      },
    }));

  async function handleAutoTicket(autoTicket) {
    const res = await updateFlightSetting({ autoTicket });
    setAutoTicket(autoTicket);
    if (res?.return) {
      getSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setAutoTicket(!autoTicket), 500);
    }
  }
  async function handleHotelAutoTicket(autoTicket) {
    const res = await updateHotelSettings({
      hotelConfirmation: autoTicket ? "Automatic" : "Manual",
    });
    setHotelAutoTicket(autoTicket);
    if (res?.return) {
      getHotelSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setHotelAutoTicket(!autoTicket), 500);
    }
  }
  async function handlePackageAutoTicket(autoTicket) {
    const res = await updateHotelSettings({
      packageConfirmation: autoTicket ? "Automatic" : "Manual",
    });
    setPackageAutoTicket(autoTicket);
    if (res?.return) {
      getHotelSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setPackageAutoTicket(!autoTicket), 500);
    }
  }
  async function handleInsuranceAutoTicket(autoTicket) {
    const res = await updateHotelSettings({
      insuranceConfirmation: autoTicket ? "Automatic" : "Manual",
    });
    setInsuranceAutoTicket(autoTicket);
    if (res?.return) {
      getHotelSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setInsuranceAutoTicket(!autoTicket), 500);
    }
  }
  async function handleEsimAutoTicket(autoTicket) {
    const res = await updateHotelSettings({
      esimConfirmation: autoTicket ? "Automatic" : "Manual",
    });
    setEsimAutoTicket(autoTicket);
    if (res?.return) {
      getHotelSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setEsimAutoTicket(!autoTicket), 500);
    }
  }
  async function handleNobiPackageAutoTicket(autoTicket) {
    const res = await updateHotelSettings({
      nobiPackageConfirmation: autoTicket ? "Automatic" : "Manual",
    });
    setNobiPackageAutoTicket(autoTicket);
    if (res?.return) {
      getHotelSuppliers();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setTimeout(() => setNobiPackageAutoTicket(!autoTicket), 500);
    }
  }

  console.log({ allSuppliers });

  return (
    <div className="container mx-auto p-4">
      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold ">Flight</h2>
        <div className="flex gap-4 items-center flex-wrap justify-end">
          <span className="flex items-center gap-2">
            Auto Ticket{" "}
            <ToggleSwitch
              toggleValue={autoTicket}
              callback={(val) => handleAutoTicket(val)}
            />
          </span>
          <SupplierSettings {...{ flightProviders, reload: getSuppliers }} />
        </div>
      </div>
      {/* Pass the loading state as well */}
      <SupplierSection
        allSuppliers={allSuppliers}
        localFlights={localFlights}
        loading={loadings.flight}
        settings={flightProviders}
        reload={() => getSuppliers()}
      />

      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold">Hotel</h2>
        <span className="flex items-center gap-2">
          Auto Confirmation{" "}
          <ToggleSwitch
            toggleValue={hotelAutoTicket}
            callback={(val) => handleHotelAutoTicket(val)}
          />
        </span>
      </div>

      <ManageHotelSuppliers
        loading={loadings?.hotel}
        data={data?.hotelSuppliers}
        reload={() => getHotelSuppliers()}
      />

      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold my-6">Tours</h2>
        <span className="flex items-center gap-2">
          Auto Confirmation{" "}
          <ToggleSwitch
            toggleValue={packageAutoTicket}
            callback={(val) => handlePackageAutoTicket(val)}
          />
        </span>
      </div>

      <ManageTourSuppliers
        loading={loadings?.hotel}
        data={data?.packageSuppliers}
        reload={() => getHotelSuppliers()}
      />

      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold my-6">Insurance</h2>
        <span className="flex items-center gap-2">
          Auto Confirmation{" "}
          <ToggleSwitch
            toggleValue={insuranceAutoTicket}
            callback={(val) => handleInsuranceAutoTicket(val)}
          />
        </span>
      </div>

      <ManageInsuranceSuppliers
        loading={loadings?.hotel}
        data={data?.insuranceSuppliers}
        reload={() => getHotelSuppliers()}
      />

      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold my-6">eSIM</h2>
        <span className="flex items-center gap-2">
          Auto Confirmation{" "}
          <ToggleSwitch
            toggleValue={esimAutoTicket}
            callback={(val) => handleEsimAutoTicket(val)}
          />
        </span>
      </div>

      <ManageEsimSuppliers
        loading={loadings?.hotel}
        data={data?.esimSuppliers}
        reload={() => getHotelSuppliers()}
      />

      <div className="flex gap-4 justify-between items-center mb-6">
        <h2 className="text-xl font-bold my-6">Nobi Packages</h2>
        <span className="flex items-center gap-2">
          Auto Confirmation{" "}
          <ToggleSwitch
            toggleValue={nobiPackageAutoTicket}
            callback={(val) => handleNobiPackageAutoTicket(val)}
          />
        </span>
      </div>

      {/* <hr className="hidden sm:block my-5" />
      <h2 className="text-xl font-bold mb-6">Hotels</h2>
   
      <SupplierSection allSuppliers={allSuppliers} loading={loading} /> */}
    </div>
  );
};

function SupplierSettings({ flightProviders, reload }) {
  const [openSettings, setOpenSettings] = useState({
    ticketAuthorized: false,
    bulkSupplierSettings: false,
  });
  const [bulkDraft, setBulkDraft] = useState(null);
  const [supplierPicker, setSupplierPicker] = useState(null);
  const [menu, setMenu] = useState(false);

  function handleChange(callback) {
    setMenu(false);
    callback && callback();
  }

  function openBulkSettings() {
    setSupplierPicker(null);
    setOpenSettings((prev) => ({ ...prev, bulkSupplierSettings: true }));
  }

  function closeBulkSettings() {
    setBulkDraft(null);
    setSupplierPicker(null);
    setOpenSettings((prev) => ({ ...prev, bulkSupplierSettings: false }));
  }

  function handleOpenPicker(picker) {
    setBulkDraft(picker.form);
    setOpenSettings((prev) => ({ ...prev, bulkSupplierSettings: false }));
    setSupplierPicker(picker);
  }

  function handlePickerApply(selectedCodes) {
    if (!supplierPicker) return;
    const nextDraft = {
      ...(bulkDraft || supplierPicker.form || {}),
      [supplierPicker.key]: selectedCodes,
    };
    setBulkDraft(nextDraft);
    setSupplierPicker(null);
    setOpenSettings((prev) => ({ ...prev, bulkSupplierSettings: true }));
  }

  function handlePickerBack() {
    setSupplierPicker(null);
    setOpenSettings((prev) => ({ ...prev, bulkSupplierSettings: true }));
  }

  return (
    <div className="flex gap-2 items-center">
      <Button1 className="!whitespace-nowrap" onClick={openBulkSettings}>
        Supplier Settings
      </Button1>
      <button
        className="bg-secondary p-2"
        onClick={(ev) => setMenu(ev.currentTarget)}
      >
        <Icon icon="mdi:menu" />
      </button>
      <Menu
        anchorEl={menu}
        open={Boolean(menu)}
        onClose={() => setMenu(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() =>
            handleChange(() =>
              setOpenSettings({ ...openSettings, ticketAuthorized: true }),
            )
          }
        >
          Ticketing Authorized Airlines
        </MenuItem>
        <MenuItem onClick={() => handleChange(openBulkSettings)}>
          Supplier Settings
        </MenuItem>
      </Menu>
      <Modal3
        open={openSettings.ticketAuthorized}
        setOpen={() =>
          setOpenSettings({ ...openSettings, ticketAuthorized: false })
        }
        title="Flight Settings"
      >
        <TicketingAuthorizedAirlined
          data={flightProviders?.ticketingAuthorizedAirlines}
          close={() =>
            setOpenSettings({ ...openSettings, ticketAuthorized: false })
          }
        />
      </Modal3>
      <Modal3
        open={openSettings.bulkSupplierSettings}
        setOpen={closeBulkSettings}
        title="Supplier Settings"
      >
        <div className="p-4 min-w-[320px] sm:min-w-[520px]">
          <BulkSupplierSettings
            data={flightProviders}
            draftForm={bulkDraft}
            onDraftChange={setBulkDraft}
            close={closeBulkSettings}
            callback={() => reload && reload()}
            onSelectField={handleOpenPicker}
          />
        </div>
      </Modal3>
      <Modal3
        open={Boolean(supplierPicker)}
        setOpen={handlePickerBack}
        title={supplierPicker?.label || "Select Suppliers"}
      >
        <div className="p-4 min-w-[320px] sm:min-w-[480px]">
          {supplierPicker ? (
            <SupplierTogglePicker
              title={supplierPicker.label}
              selected={supplierPicker.selected}
              onApply={handlePickerApply}
              onBack={handlePickerBack}
            />
          ) : null}
        </div>
      </Modal3>
    </div>
  );
}

export default Supplier;
